export default __webpack_public_path__ + "static/img35v-df7540feffba52da12c7c390ecec8c21.jpg";